import './App.css';
import AppRoutes from './routes';
import { BrowserRouter } from 'react-router-dom';
import { Suspense, useEffect, useState } from 'react';
import Loader from './components/loader';
import FloatingButtons from "./components/FloatingButtons";
import { ThemeProvider } from './context/theme';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from './components/errorFallback';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simuler un temps de chargement initial
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2500); // ⏱️ 2.5 secondes (modifiable)

    return () => clearTimeout(timer);
  }, []);

  // if (isLoading) {
  //   return <Loader />;
  // }

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <ThemeProvider>
        <BrowserRouter>
          <Suspense fallback={<Loader />}>
            <AppRoutes />
          </Suspense>
          <FloatingButtons />
        </BrowserRouter>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
